// import { Defer } from '../utils/async-store';
import { PopupManager } from '../views/popups/popup-manager';
import { BaseService } from './base-service';


export class PopupService extends BaseService {
  private get component() {
    return PopupManager.getInstance();
  }
  static serviceName = 'popupService';

  async showPopup(component: string, value: string, next: string, background?: string) {
    return this.component?.showPopup(component, value, next, background);
  }

  async showSectionLayoutPopup(section: string, next?: string) {
    return this.component?.showSectionLayoutPopup(section, next);
  }

  closePopup() {
    this.component?.close();
  }
}

PopupService.define();
